export default __webpack_public_path__ + "static/media/1617 knife block B top.22713600.png";